//公积金专区
import { $http, buildHeaders } from "./index";

//获取税局列表
export const taxbureau_list = (params) => {
  return $http.get("/admin/TaxBureau/index", { params });
};

//获取税局详情
export const taxbureau_detail = (id) => {
  return $http.get("/admin/TaxBureau/read?id=" + id, {
    headers: buildHeaders(3, "数据加载中，请稍后……"),
  });
};

//修改税局
export const taxbureau_edit = (data) => {
  return $http.post("/admin/TaxBureau/edit", data, {
    headers: buildHeaders(3),
  });
};
